var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"65debcfd9766db7234434b18c5a902b230270560"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["impact_live_web_firebase@pitcher"]={id:"65debcfd9766db7234434b18c5a902b230270560"};
      